import { createFileRoute } from '@tanstack/react-router';

import { OrgProfilePage } from '@/features/profiles/org-profile-page';

export const Route = createFileRoute('/_app/org/$orgId/profile')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <OrgProfilePage orgId={orgId} />;
}
